import { List } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useTableConfig } from 'modules/Recommendations/Benchmarks/subcomponents/Table/useTableConfig'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import { SEEN } from 'modules/Recommendations/Benchmarks/types'
import EmptyResults from 'components/EmptyResults'
import styles from 'modules/Recommendations/Benchmarks/benchmarks.module.scss'
import { ReactComponent as EmptyBenchmarks } from 'images/illustration/empty-benchmarks-list.svg'
import { useTranslation } from 'react-i18next'
import GridSpinner from 'components/UI/GridSpinner'

const Table = ({ data, filters, checkboxHandleChange, checkedIDs, processingIds, loading }) => {
  const { t } = useTranslation()
  const breakpoints = useBreakpoint()
  const dispatch = useDispatch()

  const setSeen = useCallback(
    (id = null) =>
      dispatch({
        type: SEEN,
        payload: [id],
      }),
    [],
  )

  const archiveView = useMemo(() => filters.status === 'archived', [filters])

  const [columnVisibility, setColumnVisibility] = useState()

  useEffect(() => {
    if (!breakpoints.md) {
        setColumnVisibility({ is_new: false, view: false })
    } else if (!breakpoints.lg) {
        setColumnVisibility({ is_new: false })
    } else {
        setColumnVisibility({})
    }
  }, [breakpoints, archiveView])

  const { tableState, tableConfig } = useTableConfig(
    {
      archiveView,
      checkboxHandleChange,
      filters,
      setSeen,
      meta: { checkedIDs, processingIds },
    },
    data,
  )

  useEffect(() => {
    tableState.setState((prevState) => ({ ...prevState, columnVisibility }))
  }, [columnVisibility])

  return (
    <List
      Loader={() => <GridSpinner width={32} />}
      table={tableState}
      config={tableConfig}
      loading={loading}
      EmptyComponent={() => (
        <EmptyResults
          className={styles['benchmarks-list_empty']}
          image={<EmptyBenchmarks />}
          header={t('benchmarks::table.empty_list.header')}
          text={t('benchmarks::table.empty_list.text')}
        />
      )}
    />
  )
}

Table.propTypes = {
  data: PropTypes.array,
  checkboxHandleChange: PropTypes.func,
  filters: PropTypes.object,
  checkedIDs: PropTypes.array,
  processingIds: PropTypes.array,
  loading: PropTypes.bool,
}

export default Table

